export const CASCADE_PROJECT_VERSION = '0.0.1';

// IMPEDANCE
export const MODEL_MATCH_WEIGHTS = 5;
// type
export const IMPEDANCE_PCB = 'pcb',
  IMPEDANCE_PACKAGE = 'package',
  IMPEDANCE_DIE = 'Die',
  IMPEDANCE_PCB_PRELAYOUT = 'pcb_pre_layout',
  IMPEDANCE_INTERPOSER = 'interposer',
  IMPEDANCE_SOCKET = 'socket',
  IMPEDANCE_PACKAGE_FILE = 'package_file',
  IMPEDANCE_INTERPOSER_LAYOUT = 'interposer_layout';

export const IMPEDANCE_LAYOUT_LIST = [IMPEDANCE_PCB, IMPEDANCE_PACKAGE, IMPEDANCE_PCB_PRELAYOUT, IMPEDANCE_INTERPOSER_LAYOUT],
  IMPEDANCE_PACKAGE_LIST = [IMPEDANCE_PACKAGE, IMPEDANCE_PACKAGE_FILE],
  IMPEDANCE_PCB_LIST = [IMPEDANCE_PCB, IMPEDANCE_PCB_PRELAYOUT],
  IMPEDANCE_FILE_LIST = [IMPEDANCE_DIE, IMPEDANCE_INTERPOSER, IMPEDANCE_SOCKET, IMPEDANCE_PACKAGE_FILE],
  IMPEDANCE_NO_TARGET_LIST = [IMPEDANCE_DIE, IMPEDANCE_PACKAGE, IMPEDANCE_INTERPOSER, IMPEDANCE_SOCKET, IMPEDANCE_PACKAGE_FILE, IMPEDANCE_INTERPOSER_LAYOUT],
  IMPEDANCE_POST_LIST = [IMPEDANCE_PCB, IMPEDANCE_PACKAGE, IMPEDANCE_INTERPOSER_LAYOUT]
// -- TARGET
export const TARGET_TOUCHSTONE = 'touchstone',
  TARGET_TABLE = 'table',
  TARGET_RL_VALUE = 'RLvalue';

export const TARGET_PCB_INDEX = 1,
  TARGET_PACKAGE_INDEX = 0,
  TARGET_DIE_INDEX = -1;

// Library custom model
export const ON_DIE = 'On-Die', PASSIVE = 'Passive', INTERPOSER = 'Interposer', CONNECTOR = 'Connector', PACKAGE_FILE = 'Package', SOCKET = 'Socket', IC = 'IC', PCB = 'PCB';
export const TagList = [PACKAGE_FILE, ON_DIE, PASSIVE, INTERPOSER, SOCKET, IC, PCB].sort();

// Title
export const IMPEDANCE_TITLE = 'Z Explorer',
  IR_TITLE = 'V Explorer',
  DCR_TITLE = 'R Explorer',
  TEMPLATE_TITLE = 'Sign-off Template',
  FULL_TITLE = 'Full PCB Power Tree',
  MULTI_TITLE = 'Multi PCB Power Tree',
  SINGLE_TITLE = 'Single PCB Power Tree',
  PCB_TITLE = 'PCB',
  PACKAGE_TITLE = 'Package',
  TREE_TITLE = 'Power Tree';
// -- Die Current
export const CURRENT_TRAPEZOIDAL = 'trapezoidal',
  CURRENT_PWL_TABLE = 'pwl_table',
  CURRENT_PWL_FILE = 'spice';

export const DIE_CURRENT = 'die_current';

// Sense Type
export const GENERAL = 'General',
  SENSE = 'Sense';

//Model Type
export const TOUCHSTONE = 'Touchstone', SPICE = 'SPICE'

//Template
export const VIN = 'Vin', VOUT = 'Vout', LDO = 'LDO', VSENSE = 'VSENSE', PMIC_REG = 'PMIC_Reg'
export const PMIC_DATA_TYPE_LIST = [VOUT, LDO, VSENSE, PMIC_REG]